'use strict';

var isCurrentPageCartPage = typeof shoppingCartUrl !== 'undefined' && window.location.pathname === shoppingCartUrl;

var sendAjaxRequestForValidation = function (data) {
    var deferred = jQuery.Deferred();

    $('#modal-sign-in-box-conflict-container').addClass('in-progress');

    var formURL = vitrineUrl + '/login/validate';
    $.ajax({
        url: formURL,
        method: 'POST',
        data: data,
        xhrFields: {
            withCredentials: true
        },
        success: function () {
            deferred.resolve();
        },
        error: function (jqXHR) {
            TINK.redirectIfConflict(jqXHR, false);
        }
    });
    return deferred;
};
